var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketCap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.829 17.1013C12.762 17.1013 12.693 17.0981 12.624 17.0907C11.744 16.9982 11.054 16.3379 10.864 15.4075L8.181 2.2312L5.418 9.01712C5.259 9.40628 4.898 9.65828 4.5 9.65828H1.5C0.947 9.65828 0.5 9.18193 0.5 8.59499C0.5 8.00699 0.947 7.5317 1.5 7.5317H3.844L6.35 1.37631C6.705 0.508664 7.487 0.00360034 8.376 0.0982332C9.256 0.19074 9.946 0.851043 10.136 1.78142L12.819 14.9577L15.582 8.1718C15.741 7.78264 16.101 7.5317 16.5 7.5317H19.5C20.053 7.5317 20.5 8.00699 20.5 8.59499C20.5 9.18193 20.053 9.65828 19.5 9.65828H17.156L14.65 15.8126C14.323 16.6133 13.622 17.1013 12.829 17.1013Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketCap);
export default __webpack_public_path__ + "static/media/market-cap.0b90141b85c1c7933348d1b604ca8e79.svg";
export { ForwardRef as ReactComponent };